module.exports = __webpack_public_path__ + "img/bus_04.7c13bc82.jpg";